import styled from 'styled-components';

export const EnquiryFormContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin: 15px auto;

  @media screen and (max-width: 649px) {
    flex-direction: column;
  }
`;

export const EnquiryFormColumn = styled.div`
  display: inline-flex;
  width: 100%;
  flex-direction: column;

  @media screen and (min-width: 650px) {
    width: 48%;
  }
`;

export const EnquiryFormInput = styled.div`
  margin-top: 10px;
`;

export const EnquiryFormButtonContainer = styled.div`
  max-width: 380px;
  margin: 40px auto;
`;
